import React from 'react'
import DatePicker from "react-datepicker";
import { getVoucherSuggestionNameApi } from '../../utils/ApiEndpointFunctions';
import AsyncSelect from 'react-select/async';
import { useUserContext } from '../../context/userContext';
import { getLocalizationStatus } from '../../utils/HelperFuncitons';

function VoucherFilter(props) {
  const {langPreference} = useUserContext()
  const { modalId, formik, clickHandler } = props
  const filterSuggestionName = async (inputValue) => {
    try {
      const res = await getVoucherSuggestionNameApi(formik?.values?.vendorType, inputValue)
      if (res.status === 200) {
        const uniqueNames = new Map()
        res.data?.data?.suggestion?.forEach(name => {
          const cleanName = String(name || "")
            .normalize("NFKC")
            .replace(/[\u200B-\u200D\uFEFF]/g, "")
            .trim()
            .replace(/\s+/g, " ")
          const normalisedName = cleanName
            .toLocaleLowerCase("en")
            .replace(/\s+/g, "")
          if (cleanName && !uniqueNames.has(normalisedName)) {
            uniqueNames.set(normalisedName, cleanName)
          }
        })
        return [...uniqueNames.values()].map(name => ({ label: name, value: name }))
      }
    } catch (error) {
      console.log(error)
    }
    return []
  };

  const handleVendorSelect = (e) => {
    const cleanName = String(e?.value || "")
      .normalize("NFKC")
      .replace(/[\u200B-\u200D\uFEFF]/g, "")
      .trim()
      .replace(/\s+/g, " ")
    formik.setFieldValue("name", cleanName);
  }
  const handleSelectDate = (e, type) => {
    formik.setFieldValue(type, e)
  };

  const handleApplyFilter = () => {
    const errors = Object.keys(formik?.errors)
    if(!errors.length){
      clickHandler()
    }
  }

  return (
    <>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">

              <button type="button" id="confirmModalCloseBtn" className="btn-close1" data-bs-dismiss="modal" aria-label="Close"><i className="bi bi-x-lg"></i></button>
            </div>
            <div className="modal-body ">
              <div className="">
                <div className="bb">
                  <h5>{langPreference?.filter || "Filter"}</h5>
                </div>
                <form className="my-fx">

                  <div className="ed-box">
                    <label htmlFor="challanNumber" className="form-label">{langPreference?.challan_po_number || "PO/Challan number"}</label>
                    <input type="text" className="form-control" id="challanNumber" placeholder={langPreference?.enter || "Enter "} name='challanNumber' value={formik?.values?.challanNumber} onChange={(e)=>formik?.setFieldValue("challanNumber",e?.target?.value?.toUpperCase())} onBlur={formik?.handleBlur} />

                  </div>

                  <div className="ed-box">
                    <label htmlFor="">{langPreference?.issuer_type || "Issuer type"}</label>
                    <select className="form-select" name='vendorType' aria-label="Default select example" value={formik?.values?.vendorType} onChange={formik?.handleChange} onBlur={formik?.handleBlur}  >
                      <option value="">{langPreference?.select || "Select"}</option>
                      <option value="vendor">Vendor</option>
                      <option value="subcontractor">Subcontractor</option>
                      <option value="labour">Labour</option>
                      <option value="staff">Staff</option>
                      <option value="misc">Misc</option>
                    </select>
                  </div>

                  <div className="ed-box">
                    <label htmlFor="">{langPreference?.name || "Name"}</label>
                    <AsyncSelect
                      key={formik?.values?.vendorType || "all-issuer-types"}
                      className='mb-3 col'
                      placeholder={langPreference?.select || "Select"}
                      value={formik.values?.name ? { label: formik.values.name, value: formik.values.name } : null}
                      loadOptions={filterSuggestionName}
                      defaultOptions
                      isClearable
                      onChange={handleVendorSelect}
                    />

                  </div>
                  <div className="ed-box">
                  <label htmlFor="">{langPreference?.date || "Date"}</label>
                    <select className="form-select" name='dateType' aria-label="Default select example" value={formik?.values?.dateType} onChange={e => {formik?.handleChange(e); formik.setFieldValue('to',""); formik.setFieldValue("from","")}} onBlur={formik?.handleBlur}  >
                      <option value="">{langPreference?.select || "Select"}</option>
                      <option value="0">1 Day</option>
                      <option value="1">1 Week</option>
                      <option value="2">1 Month</option>
                      <option value="3">Custom</option>
                    </select>
                    {formik?.values?.dateType === "3" && <><label htmlFor="date" className="form-label">{langPreference?.custom_range || "Custom Range"}</label>
                    <DatePicker
                      selectsRange={true}
                      dateFormat="dd/MM/yyyy"
                      className='form-select cursor-pointer'
                      startDate={formik.values?.to ? formik.values?.to : null}
                      endDate={formik.values?.from ? formik.values?.from : null}
                      maxDate={new Date(new Date(formik.values?.to ? formik.values?.to : new Date()).setTime(new Date(formik.values?.to ? formik.values?.to : new Date()).getTime() + (1 * 1000 * 60 * 60 * 24 * 180)))}
                      onChange={(update) => {
                        handleSelectDate(update[0], "to")
                        handleSelectDate(update[1], "from")
                      }}
                      isClearable={true}
                      placeholderText={(langPreference?.from || 'from') + "-" + (langPreference?.to ||"to")}
                      showDisabledMonthNavigation
                    />
                    {formik?.touched?.dateType && (formik?.errors?.to || formik?.errors?.from) ? (<div className='req-error'>{formik?.errors?.to || formik?.errors?.from}</div>) : null}
                    </>}
                  </div>

                  <div className="ed-box">
                    <label htmlFor="">{langPreference?.expenses_type || "Expenses type"}</label>
                    <select className="form-select" name='expenseType' aria-label="Default select example" value={formik?.values?.expenseType} onChange={formik?.handleChange} onBlur={formik?.handleBlur}  >
                      <option value="">{langPreference?.select || "Select"}</option>
                      <option value="inward">Inward</option>
                      <option value="outward">Outward</option>
                    </select>
                  </div>
                  <div className="ed-box">
                    <label htmlFor="">{langPreference?.voucher_type || "Voucher type"}</label>
                    <select className="form-select" name='voucherType' aria-label="Default select example" value={formik?.values?.voucherType} onChange={formik?.handleChange} onBlur={formik?.handleBlur}  >
                      <option value="">{langPreference?.select || "Select"}</option>
                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="draft">Draft</option>
                    </select>

                  </div>
                  <div className="ed-box">
                    <label htmlFor="status" className="form-label">{langPreference?.status || "Status"}</label>
                    <select className="form-select" name='status' aria-label="Default select example" value={formik?.values?.status} onChange={formik?.handleChange} onBlur={formik?.handleBlur}  >
                      <option value="">{langPreference?.select || "Select"}</option>
                      <option value="submitted">{getLocalizationStatus(langPreference,"Submitted")}</option>
                      <option value="approved">{getLocalizationStatus(langPreference,"Approved")}</option>
                      <option value="rejected">{getLocalizationStatus(langPreference,"Rejected")}</option>
                    </select>
                  </div>
                  <div className="d-flex mt-4 justify-content-end align-items-center">
                    <div className="save" onClick={handleApplyFilter}>
                    {langPreference?.apply || "Apply"}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default VoucherFilter
